document.addEventListener('DOMContentLoaded', function () {
  const slideshow = document.querySelector('section[id*="slideshow"]');
  if (!slideshow) return;

  slideshow.style.position = 'relative';

  const prevBtn = document.createElement('button');
  prevBtn.className = 'custom-arrow custom-arrow--prev';
  prevBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1027/6769/0068/files/strzalka_do_strony.png?v=1777915394" alt="Poprzedni">`;

  const nextBtn = document.createElement('button');
  nextBtn.className = 'custom-arrow custom-arrow--next';
  nextBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1027/6769/0068/files/strzalka_do_strony_2.png?v=1777915394" alt="Następny">`;

  slideshow.appendChild(prevBtn);
  slideshow.appendChild(nextBtn);

  const slider = slideshow.querySelector('slideshow-component, slider-component');

  prevBtn.addEventListener('click', () => {
    const slides = Array.from(slideshow.querySelectorAll('.slideshow__slide'));
    const current = slides.findIndex(s => s.classList.contains('is-selected') || s.getAttribute('aria-current') === 'true');
    const target = current <= 0 ? slides.length - 1 : current - 1;
    if (slider && slider.goToSlide) {
      slider.goToSlide(target);
    } else {
      const btn = slideshow.querySelector('.slideshow__prev-button, [name="previous"]');
      if (btn) btn.click();
    }
  });

  nextBtn.addEventListener('click', () => {
    const slides = Array.from(slideshow.querySelectorAll('.slideshow__slide'));
    const current = slides.findIndex(s => s.classList.contains('is-selected') || s.getAttribute('aria-current') === 'true');
    const target = current >= slides.length - 1 ? 0 : current + 1;
    if (slider && slider.goToSlide) {
      slider.goToSlide(target);
    } else {
      const btn = slideshow.querySelector('.slideshow__next-button, [name="next"]');
      if (btn) btn.click();
    }
  });
  // Drugi przycisk w sekcji Obraz z tekstem
const imageWithText = document.querySelector('#shopify-section-template--28487219970388__image_with_text_6mUW3e');
if (imageWithText) {
  const firstBtn = imageWithText.querySelector('.button, a.button, [class*="button"]');
  if (firstBtn) {
    const secondBtn = document.createElement('a');
    secondBtn.href = '/products/krzyzufki';
    secondBtn.textContent = 'Zamów byku';
    secondBtn.className = firstBtn.className;
    secondBtn.style.marginLeft = '15px';
    firstBtn.parentNode.insertBefore(secondBtn, firstBtn.nextSibling);
  }
}

});
